import { createFileRoute } from "@tanstack/react-router";

import { ProtocolEditor } from "@/features/receptura/protocol-editor";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/receptura/protokoly_/$id")({
	component: ProtocolDetailRoute,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.receptura.protokoly",
			location.pathname,
		);
	},
});

function ProtocolDetailRoute() {
	const { id } = Route.useParams();
	return <ProtocolEditor protocolId={Number(id)} />;
}
